/* eslint-disable */

import '../../assets/css/checkbox.css';

import { Card, Col, Row } from 'react-bootstrap';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  allCustomerInfos,
  getDataCustomers,
} from '../Customers/CustomersSlice';
import { allDevicesCustomer, getDataDevice } from '../Device/DeviceSlice';
import { allTenantAttribute, tenantAttributeInfos } from './AttributeSlice';
import {
  allTenantDevices,
  tenantDeviceInfos,
} from '../Dashboard/DashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import Breadcrumbs from '../../designs/Breadcrumbs/Breadcrumbs';
import Diagram from '../../components/Diagram/Diagram';
import EditBar from '../../components/Diagram/EditBar';
import FooterBar from '../../components/Diagram/FooterBar';
import PreviewImage from '../../components/PreviewImage/PreviewImage';
import { Skeleton } from 'antd';
import Timeline from '../../components/Timeline/Timeline';
import rpcV2Controller from '../../redux/api/tbRpcV2Controller';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useWebSocket from 'react-use-websocket';
import { currentTime, disconnectThreshold } from '../Dashboard/Dashboard';

const page = 0;
const pageSize = 1000;

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Attribute = () => {
  const { t } = useTranslation();
  const myDiagram = useRef(null);
  const dispatch = useDispatch();
  const { device_id } = useParams();

  let query = useQuery();
  const showDiagramC = query.get('config');

  const [size, setSize] = useState(window.innerWidth);

  const [modeState, setModeState] = useState();
  const [powerState, setPowerState] = useState();
  const [pumpState, setPumpState] = useState([]);
  const [floatState, setFloatState] = useState([]);
  const [pumpMode, setPumpMode] = useState([]);
  const [pressure, setPressure] = useState([0, 0, 0, 0, 0, 0, 0, 0]);
  const [inverter, setInverter] = useState([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);

  const [vf, setVf] = useState([]);
  const [arrMachine, setArrMachine] = useState([]);
  const [newAlert, setNewAlert] = useState(false);

  const [timeTransfer1, setTimeTransfer1] = useState();
  const [curTimeTransfer1, setCurTimeTransfer1] = useState();
  const [timeTransfer2, setTimeTransfer2] = useState();
  const [curTimeTransfer2, setCurTimeTransfer2] = useState();
  const [timeTransfer3, setTimeTransfer3] = useState();
  const [curTimeTransfer3, setCurTimeTransfer3] = useState();
  const [pressureMax, setPressureMax] = useState([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);
  const [curPressureMax, setCurPressureMax] = useState([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);

  const [sendFail, setSendFail] = useState(false);

  const dataCustomers = useSelector(allCustomerInfos);
  const attributeStatus = useSelector((state) => state.attribute.status);
  const deviceStatus = useSelector((state) => state.device.status);

  const allDevices = useSelector(allDevicesCustomer);

  const [deviceName, setDeviceName] = useState('');
  const [lastActivityTime, setLastActivityTime] = useState();
  const [lastConnectTime, setLastConnectTime] = useState();
  const [lastDisconnectTime, setLastDisconnectTime] = useState();
  const [customerName, setCustomerName] = useState('');
  const [runningOperation, setRunningOperation] = useState();

  const [isMaximize, setMaximize] = useState(false);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const [preview, setPreview] = useState(null);
  const [isShowDiagram, setShowDiagram] = useState(true);

  const [isDraw, setDraw] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isDelete, setDelete] = useState(false);

  const [notify, setNotify] = useState({
    state: 'success',
    unread: 0,
  });

  const token = localStorage.getItem('token');

  const deviceId = device_id;

  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const dataCustomer = useSelector((state) => state.profile.profile);

  const [customerId, setCustomerId] = useState();

  useEffect(() => {
    if (typeAcc === 'TENANT_ADMIN') {
      dispatch(tenantDeviceInfos({ token }));
      dispatch(tenantAttributeInfos({ token }));
      dispatch(getDataCustomers({ token }));
    } else if (typeAcc !== 'TENANT_ADMIN') {
      const customerId = dataCustomer?.customerId?.id;
      if (customerId) {
        dispatch(getDataDevice({ token, customerId, pageSize, page }));
      }
    }
  }, [dispatch, dataCustomer, token, typeAcc]);

  useEffect(() => {
    allDevices?.map((item) => {
      if (item.id.id === deviceId) {
        setDeviceName(item.name);
        setLoadingBreadcrumb(false);
        setLastConnectTime(item.attributes.lastConnectTime);
        setLastDisconnectTime(item.attributes.lastDisconnectTime);
        setLastActivityTime(item.attributes.lastActivityTime);
      }
    });
    if (deviceName !== '') setLoadingBreadcrumb(false);
  }, [allDevices, deviceId, dataCustomer, deviceName]);

  const tenantAttribute = useSelector(allTenantAttribute);
  const tenantDevices = useSelector(allTenantDevices);

  const currentAttribute =
    typeAcc === 'TENANT_ADMIN'
      ? tenantAttribute?.filter((item) => item.id.id === deviceId)[0]
      : allDevices.filter((item) => item.id.id === deviceId)[0];

  useEffect(() => {
    dataCustomers?.data?.map((item) => {
      item.device.map((device) => {
        if (device.id.id === deviceId) {
          setDeviceName(device.name);
          setCustomerName(item.name);
          setCustomerId(item.id.id);
          setLoadingBreadcrumb(false);
        } else if (device.id.id !== deviceId) {
          tenantDevices?.data?.map((item) => {
            if (item.id.id === deviceId) {
              setLastActivityTime(item.attributes.lastActivityTime);
              setLastConnectTime(item.attributes.lastConnectTime);
              setLastDisconnectTime(item.attributes.lastDisconnectTime);
              setDeviceName(item.name);
            }
          });
          setCustomerName(t('unknown'));
          setCustomerId(item.id.id);
          setLoadingBreadcrumb(false);
        }
      });
      if (item.device.length === 0) {
        tenantDevices?.data?.map((item) => {
          if (item.id.id === deviceId) {
            setDeviceName(item.name);
          }
        });
        setCustomerName(t('unknown'));
        setCustomerId(item.id.id);
        setLoadingBreadcrumb(false);
      }
    });
    if (dataCustomers.totalElements === 0) {
      tenantDevices?.data?.map((item) => {
        if (item.id.id === deviceId) {
          setDeviceName(item.name);
        }
      });
      setCustomerName(t('unknown'));
      setLoadingBreadcrumb(false);
    }
  }, [dataCustomers, deviceId, tenantDevices, t]);

  // Web Socket
  const socketUrl =
    'wss://iot.innovation.com.vn/api/ws/plugins/telemetry?token=' + token;
  const { getWebSocket } = useWebSocket(socketUrl, {
    onOpen: () => {
      var object = {
        tsSubCmds: [
          {
            entityType: 'DEVICE',
            entityId: deviceId,
            scope: 'LATEST_TELEMETRY',
            cmdId: 10,
          },
        ],
        historyCmds: [],
        attrSubCmds: [],
      };
      var data = JSON.stringify(object);
      getWebSocket().send(data);
    },
    onMessage: (event) => {
      var obj = JSON.parse(event.data).data;
      for (const i of Array(16).keys()) {
        const key = 'pump' + (i + 1);
        if (obj[key]) {
          pumpState[i] = obj[key][0][1] === 'false' ? false : true;
          setPumpState(pumpState);
        }
      }
      for (const i of Array(8).keys()) {
        const key = 'floatState' + (i + 1);
        if (obj[key]) {
          floatState[i] = obj[key][0][1] === 'false' ? false : true;
          setFloatState(floatState);
        }
      }
      for (const i of Array(8).keys()) {
        const key = 'vf' + (i + 1);
        if (obj[key]) {
          vf[i] = obj[key][0][1] === 'false' ? false : true;
          setVf(vf);
        }
      }
      for (const i of Array(8).keys()) {
        const key = 'inverter' + (i + 1);
        if (obj[key]) {
          inverter[i] = obj[key][0][1] ? obj[key][0][1] : '0';
          setInverter(inverter);
        }
      }
      for (const i of Array(8).keys()) {
        const key = 'pressure' + (i + 1);
        if (obj[key]) {
          pressure[i] = obj[key][0][1] ? obj[key][0][1] : '0';
          setPressure(pressure);
        }
      }
      for (const i of Array(16).keys()) {
        const key = 'pumpMode' + (i + 1);
        if (obj[key]) {
          pumpMode[i] = obj[key][0][1] === 'false' ? false : true;
          setPumpMode(pumpMode);
        }
      }
      if (obj['runningOperation']) {
        setRunningOperation(obj['runningOperation'][0][1]);
      }
      if (obj['mode']) {
        setModeState(obj['mode'][0][1] === 'false' ? false : true);
      }
      if (obj['power']) {
        setPowerState(obj['power'][0][1] === 'false' ? false : true);
      }
      if (obj['setTime1']) {
        setTimeTransfer1(obj['setTime1'][0][1]);
        setCurTimeTransfer1(obj['setTime1'][0][1]);
      }
      if (obj['setTime2']) {
        setTimeTransfer2(obj['setTime2'][0][1]);
        setCurTimeTransfer2(obj['setTime2'][0][1]);
      }
      if (obj['setTime3']) {
        setTimeTransfer3(obj['setTime3'][0][1]);
        setCurTimeTransfer3(obj['setTime3'][0][1]);
      }
      for (const i of Array(8).keys()) {
        const key = 'pressureMax' + (i + 1);
        if (obj[key]) {
          pressureMax[i] = obj[key][0][1] ? obj[key][0][1] : '0';
          setPressureMax(pressureMax);
          setCurPressureMax(obj['pressureMax']?.[0][1]);
        }
      }
      if (obj['alert']) {
        const data = JSON.parse(obj['alert'][0][1]);
        if (data.type !== 'success') {
          setNewAlert(true);
          let unread = 1;
          setNotify({ ...notify, unread: unread });
          if (notify.state === 'success') {
            setNotify({ ...notify, state: 'error' });
          }
        } else {
          setNewAlert(true);
          let unread = notify.unread;
          if (notify.state === 'error') {
            setNotify({ state: 'success', unread: unread });
          }
        }
      }
    },
    onClose: () => {},
  });

  useEffect(() => {
    if (myDiagram.current) {
      setWidth(myDiagram.current.offsetWidth);
      setHeight(myDiagram.current.offsetHeight);
      if (isMaximize) setHeight(myDiagram.current.offsetHeight - 45);
      if (isMaximize && window.innerHeight <= 500) setHeight(500);
    }
  }, [myDiagram.current, tenantAttribute, isMaximize, size]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  // Extend card
  const extendCard = () => {
    var card = document.getElementById('cardDiagram');

    setMaximize(!isMaximize);
    if (card.classList.contains('card-extend')) {
      document.body.style.overflow = 'visible';
      card.classList.remove('card-extend');
    } else {
      document.body.style.overflow = 'hidden';
      card.classList.add('card-extend');
    }
    if (showDiagramC === 'true') {
      card.classList.add('no-config');
    }
  };

  // Reload card
  const reload = () => {
    var card = document.getElementById('cardDiagram');
    card.classList.add('card-load');
    var div = document.createElement('div');
    var i = document.createElement('i');
    div.classList.add('card-loader');
    div.id = 'loader';
    i.classList.add('pct-loader1');
    i.classList.add('anim-rotate');
    div.appendChild(i);
    card.appendChild(div);
    setTimeout(() => {
      card.removeChild(div);
      card.classList.remove('card-load');
    }, 3000);
  };

  const [loading, setLoading] = useState(false);
  const [loadingP, setLoadingP] = useState(false);
  const [loadingBreadcrumb, setLoadingBreadcrumb] = useState(true);

  // -- RPC Send Request --
  const sendRpc = useCallback(async (device, state) => {
    setLoading(true);
    await rpcV2Controller
      .sendRpcRequest(token, deviceId, device, state)
      .catch((err) => {
        setSendFail(true);
        toast.error(`Your device ${deviceName} is offline`);
      });
    setLoading(false);
  });

  // pump state
  const togglePumpState = (e, index) => {
    // if (lastDisconnectTime > lastConnectTime) {
    if (currentTime - lastActivityTime > disconnectThreshold) {
      toast.error(`Your device ${deviceName} is offline`);
    } else if (e === true || e === false) {
      pumpState[index] = e;
      sendRpc(`pump${index + 1}`, e);
      setPumpState(pumpState);
    } else {
      pumpState[index] = e.target.checked;
      sendRpc(`pump${index + 1}`, e.target.checked);
      setPumpState(pumpState);
    }
  };

  //pump mode
  const togglePumpMode = (e, index) => {
    if (
      // lastDisconnectTime > lastConnectTime
      // && modeState === false
      currentTime - lastActivityTime >
      disconnectThreshold
      && modeState === false
    ) {
      toast.error(`Your device ${deviceName} is offline`);
    } else if (e === true || e === false) {
      pumpMode[index] = e;
      sendRpc(`pumpMode${index + 1}`, e);
      setPumpMode(pumpMode);
    } else {
      pumpMode[index] = e.target.checked;
      sendRpc(`pumpMode${index + 1}`, e.target.checked);
      setPumpMode(pumpMode);
    }
  };

  useEffect(() => {
    if (preview) {
      setLoading(false);
      dispatch(tenantAttributeInfos({ token, page, pageSize }));
    }
  }, [preview, dispatch, token, isShowDiagram]);

  useEffect(() => {
    if (attributeStatus === 'loading' || deviceStatus === 'loading') {
      setLoadingP(true);
    } else {
      setLoadingP(false);
    }
  }, [attributeStatus, deviceStatus]);

  return (
    <>
      <section className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  {loadingBreadcrumb ? (
                    <Skeleton.Button block={true} shape="round" active />
                  ) : typeAcc === 'TENANT_ADMIN' ? (
                    <Breadcrumbs
                      floor={[
                        { name: t('customer'), href: '/customers' },
                        {
                          name: customerName,
                          href:
                            customerName !== 'Unknown' &&
                            customerName !== 'Không xác định'
                              ? '/device/' + customerId
                              : 'null',
                        },
                        {
                          name: deviceName,
                          href: 'null',
                          style: {
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            color: 'gray',
                          },
                        },
                      ]}
                    />
                  ) : (
                    <Breadcrumbs
                      floor={[
                        {
                          name: deviceName,
                          style: {
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            color: 'gray',
                          },
                        },
                      ]}
                    />
                  )}
                  <div className="page-header">
                    <div className="page-block"></div>
                  </div>
                  <Row>
                    <Col md={12}>
                      <Card id="cardDiagram">
                        <Card.Body id="cardDiagramBody">
                          {currentAttribute?.attributes.operationImage &&
                          isShowDiagram ? (
                            <>
                              <EditBar
                                deviceId={deviceId}
                                setPreview={setPreview}
                                setShowDiagram={setShowDiagram}
                                isDraw={isDraw}
                                setDraw={setDraw}
                                isEdit={isEdit}
                                setEdit={setEdit}
                                setDelete={setDelete}
                                arrMachine={arrMachine}
                                width={width}
                                height={height}
                                dataDiagram={
                                  currentAttribute.attributes.operationData
                                }
                                setArrMachine={setArrMachine}
                                isOperation={
                                  typeAcc !== 'TENANT_ADMIN'
                                    ? dataCustomer?.attributes?.role?.operation
                                    : true
                                }
                                isMaximize={isMaximize}
                                reload={reload}
                                extendCard={extendCard}
                              />
                              {/* {lastConnectTime <= lastDisconnectTime */}
                              {currentTime - lastActivityTime >
                                disconnectThreshold && (
                                <div className="section-disable"></div>
                              )}
                              <div
                                className="row card-diagram"
                                ref={myDiagram}
                                id="myDiagram"
                                style={
                                  isMaximize
                                    ? {
                                        width: '80%',
                                        minHeight: '500px',
                                        height: '100%',
                                      }
                                    : null
                                }
                              >
                                <div style={{ height: '100%' }}>
                                  <Diagram
                                    vf={vf}
                                    floatState={floatState}
                                    pumpState={pumpState}
                                    deviceId={deviceId}
                                    width={width}
                                    height={height}
                                    isDraw={isDraw}
                                    isEdit={isEdit}
                                    setEdit={setEdit}
                                    isDelete={isDelete}
                                    setDelete={setDelete}
                                    arrMachine={arrMachine}
                                    setArrMachine={setArrMachine}
                                    togglePumpState={togglePumpState}
                                    togglePumpMode={togglePumpMode}
                                    disableTrafficLight={
                                      // lastConnectTime > lastDisconnectTime
                                      currentTime - lastActivityTime <=
                      disconnectThreshold
                                    }
                                    pumpMode={pumpMode}
                                    pressure={pressure}
                                    pressureMax={pressureMax}
                                    setPressureMax={setPressureMax}
                                    inverter={inverter}
                                    setInverter={setInverter}
                                    sendRpc={sendRpc}
                                    ImageDiagram={
                                      currentAttribute.attributes.operationImage
                                    }
                                    dataDiagram={
                                      currentAttribute.attributes?.operationData
                                    }
                                    isOperation={
                                      typeAcc !== 'TENANT_ADMIN'
                                        ? dataCustomer?.attributes?.role
                                            ?.operation
                                        : true
                                    }
                                    powerState={powerState}
                                  />
                                </div>
                              </div>
                              {showDiagramC !== 'true' && (
                                <div
                                  style={
                                    isMaximize
                                      ? window.innerHeight <= 500
                                        ? {
                                            width: '80%',
                                            margin: '-30px auto',
                                          }
                                        : {
                                            width: '80%',
                                            margin: '-40px auto',
                                          }
                                      : null
                                  }
                                >
                                  <FooterBar
                                    setModeState={setModeState}
                                    modeState={modeState}
                                    sendRpc={sendRpc}
                                    powerState={powerState}
                                    deviceId={deviceId}
                                    isEdit={isEdit}
                                    isDraw={isDraw}
                                    setPowerState={setPowerState}
                                    togglePumpState={togglePumpState}
                                    setNewAlert={setNewAlert}
                                    newAlert={newAlert}
                                    setNotify={setNotify}
                                    notify={notify}
                                    timeTransfer1={timeTransfer1}
                                    setTimeTransfer1={setTimeTransfer1}
                                    curTimeTransfer1={curTimeTransfer1}
                                    timeTransfer2={timeTransfer2}
                                    setTimeTransfer2={setTimeTransfer2}
                                    curTimeTransfer2={curTimeTransfer2}
                                    timeTransfer3={timeTransfer3}
                                    setTimeTransfer3={setTimeTransfer3}
                                    curTimeTransfer3={curTimeTransfer3}
                                    pressureMax={pressureMax}
                                    setPressureMax={setPressureMax}
                                    curPressureMax={curPressureMax}
                                    sendFail={sendFail}
                                    setSendFail={setSendFail}
                                    lastDisconnectTime={lastDisconnectTime}
                                    lastConnectTime={lastConnectTime}
                                    lastActivityTime={lastActivityTime}
                                    deviceName={deviceName}
                                    runningOperation={runningOperation}
                                    isPower={
                                      typeAcc !== 'TENANT_ADMIN'
                                        ? dataCustomer?.attributes?.role?.power
                                        : true
                                    }
                                    isConfig={
                                      typeAcc !== 'TENANT_ADMIN'
                                        ? dataCustomer?.attributes?.role?.config
                                        : true
                                    }
                                    isMode={
                                      typeAcc !== 'TENANT_ADMIN'
                                        ? dataCustomer?.attributes?.role?.mode
                                        : true
                                    }
                                    data={currentAttribute}
                                    dataDiagram={
                                      currentAttribute.attributes.operationData
                                    }
                                  />
                                </div>
                              )}
                            </>
                          ) : (
                            <PreviewImage
                              loading={loadingP}
                              deviceId={deviceId}
                              isShowDiagram={isShowDiagram}
                              preview={preview}
                              setPreview={setPreview}
                              setShowDiagram={setShowDiagram}
                            />
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <h5>Timeline chart</h5>
                        </Card.Header>
                        <Card.Body>
                          <Timeline
                            deviceId={deviceId}
                            dataDiagram={
                              currentAttribute?.attributes?.operationData
                            }
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Attribute;
